<template>
  <el-row class="btnrow">
    <el-row class="swtichBtn">
      <el-col :span="0">
        <!-- <el-button-group>
          <el-button size="medium"
                     type="primary">
            <div class="list"></div>
          </el-button>
          <el-button size="medium">
            <div class="card"></div>
          </el-button>
        </el-button-group> -->
        
      </el-col>
      <el-col :span="24"
              class="tagrowBtn">
        <slot></slot>
      </el-col>
    </el-row>
  </el-row>
</template>

<script>
export default {
  props: {
    taskClass: {
      type: String,
      default: ""
    },
    showCreateButton: {
      type: Boolean,
      default: true
    },
    curTask:{
        type: Object
    }
  },

  components: {
    // VueButton,
    // ApproveButton
  }
};
</script>

<style scoped>
.btnrow {
  /* background-color: #f1f6fd;
  border-top: 1px solid #f0f4fa;
  border-bottom: 1px solid #f0f4fa;
  margin-right: 35px; */
}
.swtichBtn {
  /* margin: 10px 0px 10px 24px; */
}
.tagrowBtn {
  text-align: right;
}
.leftgroup {
  float: left;
  width: 35px;
  height: 35px;
  background-color: #2b7cff;
  border-radius: 4px 0px 0px 4px;
}
.rightgroup {
  width: 35px;
  height: 35px;
  background-color: #ffffff;
  border-radius: 0px 4px 4px 0px;
  border: solid 1px #d5dae6;
  float: left;
}
.card {
  width: 17px;
  height: 17px;
  margin-left: -9px;
  margin-top: -4px;
  background: url(../../../../src/assets/img/card.png);
}
.list {
  width: 17px;
  height: 17px;
  margin-left: -8px;
  margin-top: -4px;
  background: url(../../../../src/assets/img/list.png);
}
</style>
